import React, { useEffect } from "react";
import axios from "axios";
import ElementForm from "./ElementForm";


const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiTheatra = `${protocole}${host}:${port}`

// ElementEdit Component
const ElementEdit = (params) => {
  const {typeElement, elem} = params


  useEffect(() => {
  }, [elem])

  //onSubmit handler
  const onSubmit = (elementCourant) => {
    console.log("Modif")
    //console.log(elementCourant)

    const token = localStorage.getItem('token-access') ? localStorage.getItem('token-access') : ""
    const headers = {
      'accept': 'application/json',
      'x-access-token': token
     }
     // ! indispensable pour les fichiers
    if (typeElement === 'phototheatre' ) {
      headers['content-type']= 'multipart/form-data'
    }
    console.log(`${apiTheatra}/${typeElement}/${elem.id}`)

    axios({
      //method post au lieu de put pour le file upload...
      method: 'put',
      url:  `${apiTheatra}/${typeElement}/${elem.id}`,
      headers: headers,
      data: elementCourant
    })
    .then((reponse) => {
      if (reponse.status === 200) {
        alert(typeElement + " mis à jour");
        return
      }
      else Promise.reject()
    })
    .catch((erreur) => {
      if (erreur.response.status === 401){
        alert("Une erreur d'authentification a eu lieu lors de la modification"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
          console.log(erreur.response)
      } else if (erreur.response.status === 403){
        alert("Une erreur d'autorisation a eu lieu lors de la modification"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
          console.log(erreur.response)
      } else {
        alert("Une erreur a eu lieu lors de la modification"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.message)
      }
    })

  };

  return (
    <>
    {(typeElement !== 'notice') &&
    <ElementForm
      typeAction="Modifier"
      initialValues={elem}
      typeElement={typeElement}
      onSubmit={onSubmit}
      />}
      {(typeElement === 'notice') &&
      <h3>Attention  ! pas de modification directe de notice, veuillez utiliser Zotero</h3>}
    </>
  )
}
export default ElementEdit